<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                    <div class="row breadcrumbs-top">
                    <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Vehicle Allocations </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                               
                                <li class="breadcrumb-item"><a href="#">Reports</a>
                            </li>
                            
                            <li class="breadcrumb-item active"> Analysis
                            </li>
                            <li class="breadcrumb-item active">Vehicle Allocations
                            </li>
                            </ol>
                        </div>
                    </div>
                    </div>
                </div>
            
            </div>
            
            <div class="content-body">
                <div class="card">
                        <div class="card-header py-1 filter_card_searchbgst_dock filter_rotation_onlick ">
                            <div class="container-fluid" @click="toggleCollapse">
                                <div class="row row fc_my-05">
                                     <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex">
                                            <div class="avatar-content">
                                                <em data-feather='search' class="custom-class avatar-icon font-medium-3"></em>
                                            </div>
                                        </div>
                                     </div>
                                    <h4 class="card-title d-inline-flex ml-1"> Search Vehicle Waiting Allocations </h4>
                                </div>
                            </div>
                           
                        </div>
                        <div  v-if="isCollapsed" class="collapsed-div mb-0">
                            <div class="card-body pt-1">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <label class="form-label text-left w-100">Vehicle No</label>
                                        <treeselect placeholder="Select Vehicle Number" v-model="search.vehicle_id" :options="search.vehicleNumberList"  />
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                         <label class="form-label text-left w-100">From Date</label>
                                        <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100" ></date-picker>
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">To Date</label>
                                        <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100" ></date-picker>
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 text-right mb-1 all_buttons_style">
                                        <button type="submit" class="btn btn-relief-warning mt-2 mr-1" @click="getReports()">
                                            Search
                                        </button>
                                        <button type="submit" class="btn btn-relief-secondary mt-2 " @click="resetFilters">
                                            clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                     </div>
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <div class="ml-auto w-auto px-0 right_gridviewD text-right">
                    <!-- <div class="card-body pt-1 px-0">
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                <label class="form-label text-left w-100">Vehicle No</label>
                                <treeselect placeholder="Select Vehicle Number" v-model="search.vehicle_id" :options="search.vehicleNumberList"  />
                                
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                <label class="form-label text-left w-100">From Date</label>
                                <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100" ></date-picker>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                <label class="form-label text-left w-100">To Date</label>
                                <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100" ></date-picker>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 col-lg-3  text-left home_das_all_buttons_style">
                                <button type="submit" class="btn btn-outline-primary mr-1 waves-effect  mr-1" @click="getReports()">
                                    Search
                                </button>
                                <button type="submit" class="btn btn-outline-primary waves-effect mr-1" @click="resetFilters">
                                    clear
                                </button>
                            </div>
                        </div> -->
                    </div>
                        <div class="ml-auto text-right w-auto px-0 right_gridviewD">
                            
                            <ul class="list-inline ">
                                <li class="list-inline-item" @click="toggleDiv('div2')" :class="{ active: activeButton === 'div2' }">
                                        Grid View
                                    </li>
                                    <li class="list-inline-item"  @click="toggleDiv('div1')" :class="{ active: activeButton === 'div1' }">
                                        List View  
                                    </li>
                                   
                                </ul>

                            </div>
                    </div>
                <section>
                    
                     <div class="card" v-if="showDiv1">
                        <div class="card-header bg-white pt-1 px-1 border-bottom_eee">
                            <h4 class="card-title">Vehicle Allocation Analysis</h4>
                            <h6 class="mb-0">Vehicles which are not allocated since 2+ hours of gate entry scan</h6>
                            <!-- <div v-if="isReportActive" class="px-1 text-right mobile-padding-0-2">
                                <div class="input-group-append float-right">Total Records: {{report.totalcount}}</div>
                            </div> -->
                            <!-- <div class="epg-tabs subcategory-tabs no-bg scroll-both">
                                <nav class="nav-tabs-wrapper main_divtabsview">
                                    <ul class="tabs_masters_detailstabing_pills  nav nav-pills   nav-pill-primary  pt-1 nav-tabs-items dragscroll">
                                        <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1" @click="activateReport">
                                            <a class="nav-link active" id="report_tab" data-toggle="tab" href="#report" aria-expanded="true" >Report
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1" @click="deActivateReport">
                                            <a class="nav-link" id="chart_tab" data-toggle="tab" href="#chart" aria-expanded="true" >Charts
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div> -->  
                        </div>
                        <div class="col-lg-12 mt-0 px-0">
                            <div class="card text-center mb-1">
                                <!-- <div class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0">
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active" id="report" aria-labelledby="report_tab" aria-expanded="true"> -->
                                            <div class="container px-0" >
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-hover table-striped table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left align-middle">Date</th>
                                                                <th class="text-left align-middle">Vehicle No.</th>
                                                                <th  class="text-left align-middle">Route No.</th>
                                                                <th  class="text-left align-middle">Route Path</th>

                                                                <th  class="text-left align-middle" style="width: 220px;">Entry Details</th>

                                                                <!-- <th  class="text-left align-middle">Entry Time</th> -->
                                                                <!-- <th  class="text-center align-middle">Exit Time</th> -->
                                                                <!-- <th  class="text-center align-middle">Since Gate Entry</th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <vue-element-loading :active="isReportDataLoading" />
                                                            <template v-for="(data,index) in report.list"  >
                                                                <tr>
                                                                    <td data-column="Date" class="text-left">{{data.Date}}</td>
                                                                    <td data-column="Vehicle No." class="text-left">{{data.vehicle_number_plate}}</td>
                                                                    <td data-column="Route No." class="text-left">{{formatValue(data.route_number)}}</td>
                                                                    <td data-column="Route Path" class="text-left">{{formatValue(data.route_path)}}</td>

                                                                    <!-- <td data-column="Entry Time" class="text-left">{{formatTimeStampToMonth(data.entry_time)}}</td> -->
                                                                    <!-- <td data-column="Exit Time" class="text-center">{{formatTimeStampToMonth(data.exit_time)}}</td> -->
                                                                    <!-- <td data-column="Duration" class="text-center">{{convertMinutesToTime(data.entry_time, getCurrentTimestamp())}}</td> -->
                                                                    <td data-column="Entry Details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Entry Time : </span>
                                                                            <span  class="text-center statuswisecenterview">{{formatTimeStampToMonth(data.entry_time)}}</span>
                                                                            
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Since Gate Entry: </span>
                                                                            <span  class="text-center statuswisecenterview">{{convertMinutesToTime(data.entry_time, getCurrentTimestamp())}}</span>
                                                                            
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!report.list.length">
                                                              <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="report.page" :records="report.totalcount" :per-page="report.pagelimit" @paginate="(e) => handlePageChange(e, 'report')"/>
                                                </div>
                                            </div>
                                        <!-- </div> -->
                                        <!-- <div role="tabpanel" class="tab-pane" id="chart" aria-labelledby="chart_tab" aria-expanded="false">
                                            <BarChart :chartData="chartData" />
                                            <hr />
                                            <PieChart :chartData="pieChartData" />
                                        </div> -->
                                    <!-- </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid px-0" v-if="showDiv2">
                        <div class="row">
                            <vue-element-loading :active="isReportDataLoading" />
                            <template v-for="(data,index) in report.list">
                                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-5">
                                            <div class="font-weight-bolder text-white ">{{data.vehicle_number_plate}}</div>
                                        </div>
                                        <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">{{formatTimeStampToMonth(data.entry_time)}}</div>
                                            </div>

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2">
                                   <!-- <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="photo" width="50px"  class="" :src="findImageUrl('', data.vehicle_number_plate_photo)" >
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Robin</p>
                                        </div>
                                    </div>
                                        
                                    </div> -->
                                    
                                    <!-- <div class="transaction-item">
                                        
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck-moving  font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title " style="margin-top: 12px;">Vehicle No</h6>
                                                
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">{{data.vehicle_number_plate}}</div>
                                    </div> -->
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gate Entry Date</h6>
                                                <!-- <small>{{data.Date}}</small> -->
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">{{data.Date}}</div>
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-torii-gate  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Since Gate Entry</h6>
                                                <!-- <small>{{convertMinutesToTime(data.entry_time, getCurrentTimestamp())}}</small> -->
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">{{convertMinutesToTime(data.entry_time, getCurrentTimestamp())}}</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media w-100">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-location-arrow  font-medium-5"></em>
                                                </div>
                                            </div>
                                                <div class="my-auto routePathtimelien w-100">
                                                  <h6 class="transaction-title mb-1">Route Path</h6>
                                                    <ul  class="timeline loadingcard-stati_timeline_hori" v-if="data.route_path">
                                                        <template v-for="(route, idx2) in data.route_path.split('-')">
                                                            <li class="timeline-item pt-2 pb-0 ">
                                                                <span class="timeline-point timeline-point-indicator  timeline-point-success"></span>
                                                                <div class="timeline-event">
                                                                    <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                                                                        <h6>{{route}}</h6>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </template>
                                                    </ul>
                                                    <ul  class="timeline loadingcard-stati_timeline_hori" v-else>
                                                        -
                                                    </ul>
                                               </div>
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            </template>
                            <template v-if="!report.list.length">
                              <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                            </template>
                            
                    </div>
                    <div class="pageCenter text-center mt-4 pagination_viewallpages">
                        <pagination v-model="report.page" :records="report.totalcount" :per-page="report.pagelimit" @paginate="(e) => handlePageChange(e, 'report')"/>
                    </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../../constants.js"
import { read, utils } from "xlsx";
// import schema from "../utils/schema";
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"
import BarChart from "./Charts/BarChart.vue"
import PieChart from "./Charts/PieChart.vue"

export default({
    name:'VehicleAllocationAnalysis',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        BarChart,
        PieChart,
    },
    data() {
        return {
            isLoading: false,
            isReportDataLoading: false,
            isReportActive: true,
            showDiv1: false,
            showDiv2: true,
            activeButton: 'div2',
            isCollapsed: false,
            reportData: [],
            photo_links: [],
            search: {
                vehicleNumberList: [],
                vehicle_id: null,
                start_date: null,
                end_date: null,
            },
            chartData: {
                labels: [],
                datasets: [
                    {
                      label: 'Gate Entry',
                      borderWidth: 1,
                      backgroundColor: [
                        'rgba(153, 102, 255, 0.2)',
                      ],
                      borderColor: [
                        'rgba(153, 102, 255, 1)',
                      ],
                      pointBorderColor: '#2554FF',
                      data: []
                    },
                    {
                      label: 'Gate Out',
                      borderWidth: 1,
                      backgroundColor: [
                        'rgba(255, 159, 64, 0.2)',
                      ],
                      borderColor: [
                        'rgba(255, 159, 64, 1)',
                      ],
                      pointBorderColor: '#2554FF',
                      data: []
                    }
                ]
            },
            pieChartData: {
                labels: ["IN", "OUT", "Allocated", "Not-Allocated", "Parked"],
                datasets: [{
                  borderWidth: 1,
                  borderColor: [
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255,99,132,1)',
                    '#12b886',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)'
                  ],
                  backgroundColor: [
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 99, 132, 0.2)',
                    '#96f2d7',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                  ],
                  data: [0, 0, 0, 0, 0]
                }]
            },
            report: {
                url: "/reports?type=notAllocatedSinceTwoHoursPassed",
                list: [],
                totalcount: 0,
                pageCount: 0,
                page: 1,
                pagelimit: CONSTANT.LIMIT,
                currPageNum: 0,
                pageoffset: 1,
                presignedUrls: [],
            },
        }
    } ,
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        this.getReports()
        this.getVehicleNumberList()
        // this.getDataForAnalysis()
        // this.getPieChartDataForAnalysis()
    },
    methods: {
        findImageUrl(tab='report', key) {
            tab = 'report'
            let presignedUrls = this[tab].presignedUrls
            let urlObj = presignedUrls.find(obj => obj.fileKey === key)
            if(urlObj)  return urlObj.url
            return ""
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        resetFilters() {
            this.search.vehicle_id = null
            this.report.currPageNum = 0
            this.report.page = 1
            this.report.pageoffset = 1
            this.search.start_date = null
            this.search.end_date = null
            this.getReports()
        },
        getVehicleNumberList() {
            this.searchNameMasterList('vehicle_registration_master', 'vehicle_number_plate', null, 'vehicle_id', 'vehicle_transaction_type')
                .then(result => {
                    console.log(result.data)
                  this.search.vehicleNumberList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        activateReport() {
            this.isReportActive = true
        },
         getPhotoLink(key) {
            this.getPresignUrl(key)
                .then(result => {
                    this.photo_links = [ result ]
                    // $('.imagepreview').attr('src', this.photo_link);
                    $('#imagemodal').modal('show');
                })
                .catch(e => {
                    this.displayError(e)
                    this.photo_links = []
                })
        },
        deActivateReport() {
            this.isReportActive = false
        },
        getReports(tab="report") {
            this.isReportDataLoading = true
            let payload = {
                page: this[tab].page,
                rows: this[tab].pagelimit,
                vehicle_id: this.search.vehicle_id,
                start_date: this.search.start_date,
                end_date: this.search.end_date
            }
            this.makeRequest("POST", `/reports?type=notAllocatedSinceTwoHoursPassed`, payload)
                .then(result => {
                    this.isReportDataLoading = false
                    this[tab].list = result.data.data.rows
                    this[tab].totalcount = result.data.data.count
                    console.log(result.data.data)
                    this[tab].presignedUrls = result.data.data.presignedUrls
                    this[tab].pageCount = Math.ceil(result.data.data.count / this[tab].pagelimit)
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        getDataForAnalysis() {
            this.isReportDataLoading = true
            this.makeRequest("GET", `/reports/bar/data-analysis?type=report1`)
                .then(result => {
                    this.isReportDataLoading = false
                    this.chartData.labels = result.data.data.gate_entry_pass.map(d => d.day)
                    this.chartData.datasets[0].data = result.data.data.gate_entry_pass.map(d => d.count)
                    this.chartData.datasets[1].data = result.data.data.gate_exit_pass.map(d => d.count)
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        getPieChartDataForAnalysis() {
            this.isReportDataLoading = true
            this.makeRequest("GET", `/reports/pie/data-analysis`)
                .then(result => {
                    this.isReportDataLoading = false
                    let { entry, out, allocated, notAllocated, parked } = result.data.data
                    this.pieChartData.datasets[0].data = [entry[0].count, out[0].count, allocated[0].count, notAllocated[0].count, parked[0].count]
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        handlePageChange(pageNum, tab) {
            this[tab].pageoffset=pageNum
            this[tab].currPageNum = pageNum - 1

            this.getReports(tab);
            setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(`#${tab}`).offset().top -70
                });
            }, 500);
        },
        toggleDiv(div) {
            if (this.activeButton !== div) {
                this.activeButton = div;
                this.showDiv1 = div === 'div1';
                this.showDiv2 = div === 'div2';
            }
        },
        
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
</style>